"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItemsLoading = exports.CartItemsIndicator = exports.TotalCartItems = exports.rotate = exports.scaleUp = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
exports.scaleUp = (0, flora_react_1.keyframes)({
    '0%': {
        transform: 'scale(0)',
    },
    '70%': {
        transform: 'scale(1.2)',
    },
    '100%': { transform: 'scale(1)' },
});
exports.rotate = (0, flora_react_1.keyframes)({
    '0%': {
        transform: 'rotate(0deg)',
    },
    '100%': {
        transform: 'rotate(360deg)',
    },
});
const scaleIndicator = (0, flora_react_1.keyframes)({
    '0%': { opacity: 0 },
    '70%': { opacity: 0 },
    '100%': { opacity: 1 },
});
exports.TotalCartItems = (0, flora_react_1.styled)(flora_react_1.Flex, {
    fontSize: '$xrestricted',
    backgroundColor: '$success-standard',
    color: '$backgroundPrimary',
    borderRadius: '$pill',
    width: '$4',
    height: '$4',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: -7,
    top: 7,
    variants: {
        triggerAnimation: {
            true: {
                animation: `${exports.scaleUp} 0.5s ease-out`,
            },
        },
    },
});
exports.CartItemsIndicator = (0, flora_react_1.styled)('span', {
    variants: {
        triggerAnimation: {
            true: {
                animation: `${scaleIndicator} 0.5s ease-out`,
            },
        },
    },
});
exports.CartItemsLoading = (0, flora_react_1.styled)(flora_react_icons_1.CircumferenceRadiusIcon, {
    backgroundColor: '$success-standard',
    color: '$backgroundPrimary',
    borderRadius: '$pill',
    width: '$4',
    height: '$4',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: -7,
    top: 7,
    animation: `${exports.rotate} 1s linear infinite`,
});
